import api from '@/js/services/api';

export default {

    registerUser(form) {
        return api().post(`/artist/register`, form);
    },

    userLogin(form) {
        return api().post(`/login`, form);
    },

    clientRegister(form) {
        return api().post(`/client/register`, form);
    },

    resetPassword() {
        return api().post(`/user/forgot-password`);
    }
}
